module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"title1description":"店舗に必要なすべての情報が一つに「Flow GO」","title2":"円滑なコミュニケーションの実現","title2description":"Flow GOのモバイルKPIダッシュボードによりいつでもどこでもリアルタイムに店舗のデータを確認することが可能に。データを確認したらアプリ内からチームにデータを共有したりチャットでメッセージを送ることもできます。","title3description":"迅速なコミュニケーションが必要とされる今、目標達成のためにいち早く必要なKPIを把握することが必要です。Flow GOは店舗の施策を決定する際、データに基づいた的確な意思決定をサポートします。","title3":"データの可視化"}}')
  delete Component.options._Ctor
}
